import { render, staticRenderFns } from "./customerAnalysis.vue?vue&type=template&id=3c4c8e20&scoped=true&"
import script from "./customerAnalysis.vue?vue&type=script&lang=js&"
export * from "./customerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./customerAnalysis.vue?vue&type=style&index=0&id=3c4c8e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4c8e20",
  null
  
)

export default component.exports